module.exports = __webpack_public_path__ + "static/media/crossIconDark.7f709d74.svg";